import { Box, Modal, ModalBody, Text } from '@bechtel/gds';
import { OperatorType, SortType, ToolRoom } from '@bechtel/ht-types';
import { get, map } from 'lodash';
import { FC, useEffect } from 'react';
import LoadingIndicator from '~/components/loading-indicator';
import { Map, MapComponent, Marker, MarkerCluster } from '~/components/map';
import { ToolRoomMarker } from '~/components/map/markers/tool-room-marker';
import { useGetToolRooms } from '~/hooks';
import { BoxWithBorderStyled } from '~/styles';
import { ModalCloseStyled, ModalHeaderStyled } from '~/styles/modal-styles';
import { ToolRoomItemStyled } from './styled';

export const SelectToolRoomDialog: FC<any> = ({ onCancel, onSelect }) => {
  const { getToolRoomList, data, loading, error } = useGetToolRooms(true);

  const toolRooms: ToolRoom[] = get(data, 'searchToolRooms.items', []);
  const toolRoomsWithLatLng = toolRooms?.filter((toolRoom) => toolRoom.latitude && toolRoom.longitude);
  const toolRoomMarkers: Marker[] = map(toolRoomsWithLatLng, (toolRoom) => {
    return {
      item: toolRoom,
      position: { lat: toolRoom.latitude || 0, lng: toolRoom.longitude || 0 },
    };
  });

  const markerCluster: MarkerCluster = {
    type: 'Toolrooms',
    icon: 'screwdriver-wrench',
    imageIcon: '/images/tool-room.svg',
    selectedImageIcon: '/images/toolroom-border.svg',
    markers: toolRoomMarkers,
  };

  useEffect(() => {
    getToolRoomList({
      filterInput: {
        and: [
          {
            field: 'isActive',
            operator: OperatorType.EQUAL,
            value: 'true',
          },
        ],
      },
      sortInput: [{ field: 'name', sort: SortType.ASC }],
    });
  }, []);

  return (
    <>
      <Modal visible={true} style={{ width: '900px', minHeight: '600px' }}>
        <ModalHeaderStyled title={`Select Toom Room for Reservation`}>
          <ModalCloseStyled onClick={onCancel}></ModalCloseStyled>
        </ModalHeaderStyled>
        <ModalBody>
          <Box flexGrow={{ sm: '1' }} py={{ sm: '500' }}>
            {!loading && error && <Box>There was an error loading the Tool Rooms. Please try again later!!</Box>}
            {loading && !error && <LoadingIndicator></LoadingIndicator>}
            {!loading && !error && (
              <>
                <Box pl={{ sm: '500' }} flexBasis={{ sm: '80%' }}>
                  <Map>
                    <MapComponent
                      style={{ width: '100%', height: '100%' }}
                      center={{
                        //TODO - Fetch from user project settings
                        lat: 40.670248,
                        lng: -80.338754,
                      }}
                      zoom={15}
                      mapTypeId={'satellite'}
                    >
                      {markerCluster.markers.map((marker) => {
                        return (
                          <ToolRoomMarker
                            key={marker.item.id}
                            position={marker.position}
                            icon={markerCluster.imageIcon}
                            highlightIcon={markerCluster.selectedImageIcon}
                            markerPopUpComponent={markerCluster.popupComponent}
                            onSelect={() => {
                              open();
                              onSelect(marker.item);
                            }}
                            toolRoom={marker.item}
                          />
                        );
                      })}
                    </MapComponent>
                  </Map>
                </Box>
                <div style={{ overflowY: 'auto', flexGrow: '1' }}>
                  <BoxWithBorderStyled flexBasis={{ sm: '20%' }} flexDirection={{ sm: 'column' }}>
                    <BoxWithBorderStyled borderBottomColor={'grey.300'}></BoxWithBorderStyled>
                    {map(toolRooms, (toolRoom) => {
                      return (
                        <ToolRoomItemStyled
                          key={toolRoom.id}
                          onClick={() => {
                            onSelect(toolRoom);
                          }}
                        >
                          <Text color="blue.1000" size="400" weight={'600'} style={{ lineHeight: 1.5 }}>
                            {toolRoom.description}
                          </Text>
                        </ToolRoomItemStyled>
                      );
                    })}
                  </BoxWithBorderStyled>
                </div>
              </>
            )}
          </Box>
        </ModalBody>
      </Modal>
    </>
  );
};
